__turbopack_context__.v({
  "className": "karla_5d2dd0e7-module__zA4O2W__className",
  "variable": "karla_5d2dd0e7-module__zA4O2W__variable",
});
